import httpCommon from "./http-common";

// Get all receipt items
const getAllReceipts = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/receipts/${businessId}?skip=${skip}&limit=${limit}`);
};

const getAllRecentReceipts = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/recentReceipts/${businessId}?skip=${skip}&limit=${limit}`);
};

const getTotalPaidAmount = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/totalPaidAmount/${businessId}?skip=${skip}&limit=${limit}`);
};

// Get receipt item count
const getAllReceiptsCount = () => {
  return httpCommon.get("/v1/get/count/receipts");
};

const getReceiptsTotalValue = () => {
  return httpCommon.get("/v1/get/totalValue/receipts");
};

const getReceiptById = (id: number) => {
  return httpCommon.get(`/v1/get/receipt/${id}`);
};

// Create receipt
const createReceipt = (data: any, businessId: number) => {
  return httpCommon.post(`/v1/add/receipt/${businessId}`, data);
};

// Update specific receipt item
const updateSpecificReceipt = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/receipts/${id}`, data);
};

// Delete receipt
const deleteReceipt = (id: number) => {
  return httpCommon.delete(`/v1/delete/receipt/${id}`);
};

// Admin functions
const getAllReceiptsAsAdminUser = (skip = 0) => {
  return httpCommon.get(`/v1/admin/get/receipts?skip=${skip}`);
};

const getAllReceiptsCountAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/count/receipts");
};

const getReceiptsTotalValueAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/totalValue/receipts");
};

const ReceiptService = {
    getAllReceipts,
    getAllRecentReceipts,
    getTotalPaidAmount,
    getAllReceiptsCount,
    getReceiptsTotalValue,
    getReceiptById,
    createReceipt,
    updateSpecificReceipt,
    deleteReceipt,
    getAllReceiptsAsAdminUser,
    getAllReceiptsCountAsAdminUser,
    getReceiptsTotalValueAsAdminUser,
};
export default ReceiptService;
